import React from "react";

  import { useNavigate } from "react-router-dom";
import { Post } from "store/campaigns/campaignPosts/campaignPosts.types";
import * as S from "./index.styles";

import * as P from "./index.styles";
import RelatedPostItem from "../RelatedPostItem";

interface FundraisingDetailPostsProps {
  posts: Post[];
  onSeeAll?: () => void;
}

const FundraisingDetailPosts: React.FC<FundraisingDetailPostsProps> = ({
  posts,
  onSeeAll
}) => {
  // Show 5 posts initially
  const displayedPosts = posts?.slice(0, 5);

  const navigate = useNavigate();

  const handlePostClick = (postId: Post["id"]) => {
    navigate(`/post/${postId}`);
  };

  return (
    <P.PostsSection>
      <S.PostsSectionHeader>
        <S.PostsSectionTitle>Related Posts</S.PostsSectionTitle>
        {/*{posts?.length > 5 && (
          <S.SeeAllLink type="button" onClick={onSeeAll}>
            see all
          </S.SeeAllLink>
        )}*/}
      </S.PostsSectionHeader>
      {posts && posts.length > 0 ? (
        <P.PostsGrid>
          {displayedPosts?.map((post, key) => (
            <RelatedPostItem key={key} post={post} onPostClick={handlePostClick} />
          ))}
        </P.PostsGrid>
      ) : (
        <S.PostsEmptyState>No posts found</S.PostsEmptyState>
      )}
    </P.PostsSection>
  );
};

export default FundraisingDetailPosts;
